import React from 'react';

const SvgMa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MA_svg__b" fill="#fff">
        <use xlinkHref="#MA_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MA_svg__a" />
      <path fill="#E33B44" mask="url(#MA_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M16.293 13.156l-.846-2.686 2.263-1.675-2.816-.026L14 6.1l-.894 2.67-2.816.026 2.263 1.675-.846 2.686L14 11.52l2.293 1.635z"
        stroke="#0A6135"
        strokeWidth={1.333}
        mask="url(#MA_svg__b)"
      />
    </g>
  </svg>
);

export default SvgMa;
